import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { onMounted } from 'vue';

import { useStore } from '@/store';
import {
  addSubscribersForMetamaskEvents,
  getProvider,
  isMetamaskConnected,
  setupStore,
} from '@/common/get-web3';
import { useBSCMainNetwork, useBSCTestNetwork } from './common/metamask-apis';
import { WalletConnectMethod } from '@/store/state';
import { currentEnvironment, ProjectEnvironment } from '@/common/project-environment';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

onMounted(async () => {
  const isConnected = await isMetamaskConnected();
  const provider = await getProvider();
  // 切换网络
  if (provider !== null) {
    if (currentEnvironment() === ProjectEnvironment.Development) {
      await useBSCTestNetwork();
    } else {
      await useBSCMainNetwork();
    }
  }
  if (store.state.web3 === null && isConnected) {
    await setupStore(provider, store, WalletConnectMethod.Metamask);
    console.log(store.state);
    addSubscribersForMetamaskEvents(provider);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})